

export enum KalturaEntryType {
    automatic = '-1',
	conferenceEntryServer = 'conference.CONFERENCE_ENTRY_SERVER',
	data = '6',
	document = '10',
	externalMedia = 'externalMedia.externalMedia',
	liveChannel = '8',
	liveStream = '7',
	mediaClip = '1',
	mix = '2',
	playlist = '5',
	room = 'room.room',
	sipEntryServer = 'sip.SIP_ENTRY_SERVER'
}